module.exports = __webpack_public_path__ + "img/fdi_logo.e1185a2b.png";